// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.80.0',
  revision: 'c5c54835e',
  branch: 'master',
  date: 'Thu, 23 Oct 2025 11:05:41 GMT'
};